import * as DateSelector from '../../components/date-selector'
import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import * as CommunityTypes from '../community-config/types'
import * as Constants from './constants'
import * as Types from './types'

interface ViewState {
  dateSelect: IsActive.Filter,
  filter: IsActive.Filter,
  start?: SelectedDate,
  end?: SelectedDate,
}

type SelectedDate = string
export type FetchTrainingPayload = Request.RequestOptions<{startDate?: SelectedDate}>

const trainingUrlFor = (
  community: CommunityTypes.CommunityIdentifier,
  viewState: ViewState,
): string => {
  const selectMode = viewState.dateSelect.value
  const filter = viewState.filter
  const startDate = viewState.start
  const endDate = viewState.end
  const path = (selectMode === Constants.DATE_SELECT_LAST_NEWSBRIEF_MODE ? 'last_newsbrief' : `date/${startDate}`)
  const url = `${Constants.SERVER_RESOURCE}/${community}/${path}/training/${Constants.TRAINING_MODEL_NAME}` +
    `?type=training&${IsActive.asQueryString(filter)}`
  return  endDate ? `${url}&end_date=${endDate}` : url
}

export const fetchTrainingData = (
  community: CommunityTypes.CommunityIdentifier,
  viewState: ViewState,
) => Request.requestActionCreator<FetchTrainingPayload>(Constants.FETCH_TRAINING_CONTENT)
  ({
    method: 'GET',
    url: trainingUrlFor(community, viewState),
  })

export const initializeDate = (date: DateSelector.SelectedDate): DateSelector.SelectDateAction => ({
  date: date.format('YYYY-MM-DD'),
  type: Constants.INITIALIZE_DATE,
})

export const selectDateRange: DateSelector.SelectDateRange = (dateRange: DateSelector.DateRange) => {
  return DateSelector.selectDateRange(dateRange, Constants.SELECT_TRAINING_DATE_RANGE)
}

export interface TrainPostPayload extends Request.RequestOptions {
  payload: {
    id: number,
    category: string,
  }
}

export type TrainPostAction = Request.RequestAction<TrainPostPayload>

export type TrainPostActionCreator =
  (post: Types.TrainingPost, newCategory: string) => TrainPostAction

export const updateUI = (viewState: Types.TrainingViewState) => {
  return DateSelector.selectDateRangeAndFilter(
    {
      dateSelect: viewState.dateSelect,
      end: viewState.end,
      start: viewState.start,
    },
    viewState.filter,
    Constants.SELECT_TRAINING_DATE_RANGE_AND_FILTER)
}



// WEBPACK FOOTER //
// ./src/pages/training/actions.ts